import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppointmentRoutingModule } from './appointment-routing.module';
import { AppointmentComponent } from './pages/appointment/appointment.component';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../shared/shared.module';
import { AppointmentListComponent } from './components/appointment-list/appointment-list.component';
import { AppointmentItemComponent } from './components/appointment-item/appointment-item.component';
import { AppointmentWizardModule } from '../appointment-wizard/appointment-wizard.module';
import { AppointmentActionsModalComponent } from './components/appointment-actions-modal/appointment-actions-modal.component';

@NgModule({
    declarations: [
        AppointmentComponent,
        AppointmentListComponent,
        AppointmentItemComponent,
        AppointmentActionsModalComponent,
    ],
    imports: [
        CommonModule,
        AppointmentRoutingModule,
        IonicModule,
        SharedModule,
        AppointmentWizardModule,
    ],
})
export class AppointmentModule {}
